// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"497":"4610a4c9","794":"4610a4c9","870":"4610a4c9"}[chunkId] + ".chunk.css";
};